import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DateFiltersFilesClients } from '../../files-clients/interface/filters-files-clients.interface';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-filter-dashboard-client',
  templateUrl: './filter-dashboard-client.component.html',
  styleUrls: ['./filter-dashboard-client.component.scss'],
  animations: [
    trigger('slideInFromTop', [
      state('void', style({ transform: 'translateY(-100%)', opacity: 0 })),
      transition(':enter', [
        animate('500ms ease-in', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('500ms ease-out', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class FilterDashboardClientComponent {
  @Output() topFilter: EventEmitter<any> = new EventEmitter();
  @Output() public changeClientFileFilter = new EventEmitter<DateFiltersFilesClients>;
  @ViewChild('select') select: MatSelect;
  public formFilter!: FormGroup;
  public anioActual: number = new Date().getFullYear();
  public panelOpenState = false;
  selected = 'Personalizado';
  public viewDatpicker = false;
  public selectedChipIndex: number = 0;
  public lastSelectableChipIndex: number = 5;
  readonly filtrosf: string[] = ['Mes Actual','Mes Anterior','3 Meses','6 Meses','1 Año'];
  public desde = "Desde";
  public hasta = "Hasta";

  @ViewChild('picker') picker: MatDateRangePicker<Date>;

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      start: [''],
      end: [''],
      generalFilter: [''],
      preference: [1],
    });
    this.filtroMeses(1);
  }

  ngOnInit() {

  }

  preferences: any[] = [
    { value: 1, viewValue: 'Último Mes' },
    { value: 2, viewValue: 'Mes Anterior' },
    { value: 3, viewValue: '3 Meses' },
    { value: 6, viewValue: '6 Meses' },
    { value: 111, viewValue: 'Año Actual' },
    { value: 222, viewValue: 'Año '+(this.anioActual-1) },
    { value: 333, viewValue: 'Año '+(this.anioActual-2) },
    { value: 444, viewValue: 'Todo'},
    { value: 0, viewValue: 'Personalizado' }
  ];

  addPreference(value: number, viewValue: string) {
    this.preferences.push({ value: value, viewValue: viewValue });
  }

  filtroGeneral(event: any) {
    this.sendUpdatedFilters();
  }

  private sendUpdatedFilters(){
    const {start, end, generalFilter, preference} = this.formFilter.value;
    const startISO: string = (typeof start === 'string') ?  start : new Date(start).toISOString();
    const endISO : string = (typeof end === 'string') ? end : new Date(end).toISOString();
    const filterClientFilter: DateFiltersFilesClients = {
      start: startISO,
      end: endISO,
      search: generalFilter,
      preference: preference
    };
    this.changeClientFileFilter.emit(filterClientFilter);
  }

  // Método para actualizar dinámicamente el valor de la opción de filtro
  actualizarOpcionFiltro() {
    const valorPersonalizado = 'personalizado';

    // Verificar si se ha utilizado el rango de días
    if (
      this.formFilter.get('start')!.value &&
      this.formFilter.get('end')!.value &&
      !this.opcionesIncluyenPersonalizado()
    ) {
      // Agregar la opción "Personalizado" si no está en la lista
      this.preferences.push({
        value: valorPersonalizado,
        viewValue: 'Personalizado',
      });

      // Actualizar el valor del formulario
      this.formFilter.patchValue({
        preference: valorPersonalizado,
      });
    } else if (
      (!this.formFilter.get('start')!.value ||
        !this.formFilter.get('end')!.value) &&
      this.opcionesIncluyenPersonalizado()
    ) {
      // Si no se ha utilizado el rango de días, eliminar la opción "Personalizado"
      this.removerPersonalizado();
    }
  }

  opcionesIncluyenPersonalizado() {
    return this.preferences.some((opcion) => opcion.value === 'personalizado');
  }

  // Método para remover la opción "Personalizado" de las opciones
  removerPersonalizado() {
    this.preferences = this.preferences.filter(
      (opcion) => opcion.value !== 'personalizado'
    );
  }

  filtroMeses(number: number) {
    let end, start;
    const now = new Date();
    
    if (number === 1 || number === 3 || number === 6) {
      end = now.toISOString();
      let date = new Date(end);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1
      let year = (date.getUTCFullYear()) % 100;
      this.hasta = day + "/" + month + "/" + year;
      start = new Date(now.setMonth(now.getMonth() - number)).toISOString();
      let date1 = new Date(start);
      let day1 = date1.getUTCDate();
      let month1 = date1.getUTCMonth() + 1;
      let Year1  = (date1.getUTCFullYear()) % 100;
      this.desde = day1 + "/" + month1 + "/" + Year1;
    } else if(number === 2) {
      end = new Date(now.getFullYear(), now.getMonth(), 0).toISOString(); // Día 0 del mes actual es el último día del mes anterior
      let date = new Date(end);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1
      let year = (date.getUTCFullYear()) % 100;
      this.hasta = day + "/" + month + "/" + year;
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1).toISOString();
      let date1 = new Date(start);
      let day1 = date1.getUTCDate();
      let month1 = date1.getUTCMonth() + 1
      let Year1  = (date1.getUTCFullYear()) % 100;
      this.desde = day1 + "/" + month1 + "/" + Year1;
    } else if (number === 111) {
      end = now.toISOString();
      let date = new Date(end);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1
      let year = (date.getUTCFullYear()) % 100;
      this.hasta = day + "/" + month + "/" + year;
      const start = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()).toISOString(); // Fecha de hace un año
      let date1 = new Date(start);
      let day1 = date1.getUTCDate();
      let month1 = date1.getUTCMonth() + 1;
      let Year1 = date1.getUTCFullYear() % 100;
      this.desde = day1 + "/" + month1 + "/" + Year1;
    } else if (number === 222) {
      end = new Date(now.getFullYear() - 1, 11, 30).toISOString(); // 30 de diciembre del año pasado
      let date = new Date(end);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1
      let year = (date.getUTCFullYear()) % 100;
      this.hasta = day + "/" + month + "/" + year;
      start = new Date(now.getFullYear() - 1, 0, 1).toISOString(); // 1 de enero del año pasado
      let date1 = new Date(start);
      let day1 = date1.getUTCDate();
      let month1 = date1.getUTCMonth() + 1
      let Year1  = (date1.getUTCFullYear()) % 100;
      this.desde = day1 + "/" + month1 + "/" + Year1;
    } else if (number === 333) {
      end = new Date(now.getFullYear() - 2, 11, 30).toISOString(); // 30 de diciembre de hace dos años
      let date = new Date(end);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1
      let year = (date.getUTCFullYear()) % 100;
      this.hasta = day + "/" + month + "/" + year;
      start = new Date(now.getFullYear() - 2, 0, 1).toISOString(); // 1 de enero de hace dos años
      let date1 = new Date(start);
      let day1 = date1.getUTCDate();
      let month1 = date1.getUTCMonth() + 1
      let Year1  = (date1.getUTCFullYear()) % 100;
      this.desde = day1 + "/" + month1 + "/" + Year1;
    } else if (number === 444) {
      end = now.toISOString();
      let date = new Date(end);
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1
      let year = (date.getUTCFullYear()) % 100;
      this.hasta = day + "/" + month + "/" + year;
      start = new Date(now.getFullYear() - 7, 0, 1).toISOString();
      let date1 = new Date(start);
      let day1 = date1.getUTCDate();
      let month1 = date1.getUTCMonth() + 1
      let Year1  = (date1.getUTCFullYear()) % 100;
      this.desde = day1 + "/" + month1 + "/" + Year1;
    }

    this.formFilter.patchValue({
      end: end,
      start: start,
    });

    const filterClientFilter: DateFiltersFilesClients = {
      start: start,
      end: end,
      search: this.formFilter.get('generalFilter')!.value,
      preference: this.formFilter.get('preference')!.value
    };

    this.changeClientFileFilter.emit(filterClientFilter);
  }

  filtrarPorFecha() {
    this.selectedChipIndex = -1;
    const endValue = this.formFilter.controls['end']?.value;
    const startValue = this.formFilter.controls['start']?.value;
    this.formFilter.controls['preference']?.setValue(0);

    const dateDesde = new Date(startValue);
    const dateHasta = new Date(endValue);

    let diaDesde = dateDesde.getUTCDate();
    let mesDesde = dateDesde.getUTCMonth()+1;
    let anioDesde = (dateDesde.getUTCFullYear() % 100);
    let diaHasta = dateHasta.getUTCDate();
    let mesHasta = dateHasta.getUTCMonth()+1;
    let anioHasta = (dateHasta.getUTCFullYear() % 100);
 
    this.desde = diaDesde+"/"+mesDesde+"/"+anioDesde;
    this.hasta = diaHasta+"/"+mesHasta+"/"+anioHasta;

    console.log(this.desde);

    this.sendUpdatedFilters();
  }

  public openDatePicker() {
    this.picker.open();
  }

  public selectChip(index: number): void {
    console.log("sdsdsdsdsds");
    if (this.selectedChipIndex !== index) {
      this.selectedChipIndex = index;
      switch (index) {
        case 0:
          this.filtroMeses(1);
          this.viewDatpicker=false;
          break;
        case 1:
          this.filtroMeses(2);
          this.viewDatpicker=false;
          break;
        case 2:
          this.filtroMeses(3);
          this.viewDatpicker=false;
          break;
        case 3:
          this.filtroMeses(6);
          this.viewDatpicker=false;
          break;
        case 4:
          this.filtroMeses(111);
          this.viewDatpicker=false;
          break;
        case 5:
          //this.filtroMeses(0);
          this.openDatePicker();
          this.selectedChipIndex = -1;
          this.lastSelectableChipIndex = -1;
          //this.mostrarDatapicker();
          break;
      }
    }
  }

  public mostrarDatapicker() {
    this.desde = "";
    this.hasta = "";
    this.viewDatpicker = !this.viewDatpicker; 
  }

  onChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const indiceSeleccionado = selectElement.selectedIndex;
    this.selectChip(indiceSeleccionado);
  }

}
